import { render, staticRenderFns } from "./Congestion.vue?vue&type=template&id=059ae375&scoped=true&"
import script from "./Congestion.vue?vue&type=script&lang=js&"
export * from "./Congestion.vue?vue&type=script&lang=js&"
import style0 from "./Congestion.vue?vue&type=style&index=0&id=059ae375&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059ae375",
  null
  
)

export default component.exports